export default "__VITE_ASSET__JsZR05UF__"